import { apiPath, graphQLEndpoint } from '../constants';
import { errorFactory } from './errors';
import { updateIdleTimeoutDate, queryParamsToQueryString } from './generic';

const AUTHENTICATION_ERROR_CODES = [402, 403];
const POST_TIMEOUT = 120000;

export const isJson = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

export const postData = async ({
    endpoint,
    body,
    graphQL = false,
    queryParams = {},
}) => {
    const queryString = queryParamsToQueryString(queryParams);
    const postEndpoint = graphQL ? graphQLEndpoint : `${apiPath}${endpoint}${queryString}`;
    const res = await Promise.race([
        fetch(postEndpoint, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',
            },
            body: isJson(body) ? body : JSON.stringify(body),
        }),
        new Promise((_, reject) => {
            setTimeout(
                () =>
                    // eslint-disable-next-line implicit-arrow-linebreak
                    reject(errorFactory.timeout()),
                POST_TIMEOUT,
            );
        }),
    ]);
    if (AUTHENTICATION_ERROR_CODES.includes(res.status)) {
        console.error(
            `There has been an error with the request: ${res.status}`,
        );
    }

    // For 403 errors, try to parse and throw detailed error message
    if (res.status === 403 && !res.ok) {
        try {
            const resClone = res.clone();
            const errorJson = await resClone.json();
            if (errorJson && errorJson.message) {
                throw errorFactory.err(errorJson.message);
            }
        } catch (parseError) {
            // If JSON parsing failed (SyntaxError), continue to return response
            if (parseError instanceof SyntaxError) {
                // Response wasn't valid JSON, continue to return original response
            } else {
                // Re-throw errors from errorFactory or other non-parse errors
                throw parseError;
            }
        }
    }

    updateIdleTimeoutDate();
    return res;
};
